import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ITemplateModuleScheme } from '../types/TemplateModuleScheme';
import { IBaseEditor } from '@start-set/wakadoo-editor-core/impl/IBaseEditor';

const initialState: ITemplateModuleScheme = {
	editor: null,

	onGalleryModuleClick: null,
	onEntityModuleClick: null,

	isTemplateModalActive: false,
	isEditTemplateModuleModalActive: false,

	bindingModuleId: undefined,
	isBindingTagModuleModalActive: false,

	onCloseModuleModal: null,

	selectedCategoryIds: [],
	selectedTagsIds: [],

	isTagsDropdownOpen: false,

	moduleId: '',
};

export const templateModuleSlice = createSlice({
	name: 'templateModule',
	initialState,
	selectors: {
		getIsTemplateModuleActive: (state) => state.isTemplateModalActive,
		getIsEditTemplateModuleActive: (state) => state.isEditTemplateModuleModalActive,

		getBindingModuleId: (state) => state.bindingModuleId || undefined,
		getIsBindingTagModuleModalActive: (state) => state.isBindingTagModuleModalActive || false,

		getEntityModuleClick: (state) => state.onEntityModuleClick,
		getGalleryModuleClick: (state) => state.onGalleryModuleClick,

		getCloseModuleModal: (state) => state.onCloseModuleModal,

		getSelectedCategoryIds: (state) => state.selectedCategoryIds || [],
		getSelectedTagsIds: (state) => state.selectedTagsIds,

		getIsTagsDropdownOpen: (state) => state.isTagsDropdownOpen || false,

		getModuleId: (state) => state.moduleId,
		getEditor: (state) => state.editor,
	},
	reducers: {
		setCloseModuleModalFunc: (state, action: PayloadAction<() => void>) => {
			state.onCloseModuleModal = action.payload;
		},

		setOnEntityModuleClick: (state, action: PayloadAction<(moduleId: string) => void>) => {
			state.onEntityModuleClick = action.payload;
		},
		setOnGalleryModuleClick: (state, action: PayloadAction<(moduleId: string) => void>) => {
			state.onGalleryModuleClick = action.payload;
		},
		setModuleId(state, action: PayloadAction<string>) {
			state.moduleId = action.payload;
		},

		setBindingModuleId(state, action: PayloadAction<string | undefined>) {
			state.bindingModuleId = action.payload;
		},
		setIsBindingTagModuleModalActive(state, action: PayloadAction<boolean>) {
			state.isBindingTagModuleModalActive = action.payload;
		},

		setIsTemplateModuleActive: (
			state,
			action: PayloadAction<{ editor?: IBaseEditor | null; active: boolean }>
		) => {
			const { editor = null, active } = action.payload;
			if (active) {
				editor?.disableInteractive();
			} else {
				state.editor?.enableInteractive();
			}
			state.isTemplateModalActive = active;
			state.editor = editor;
		},

		setIsEditTemplateModuleActive: (state, action: PayloadAction<boolean>) => {
			state.isEditTemplateModuleModalActive = action.payload;
		},

		setSelectedCategoryIds: (state, action: PayloadAction<number[]>) => {
			state.selectedCategoryIds = action.payload;
		},
		setSelectedTagsIds: (state, action: PayloadAction<number[]>) => {
			state.selectedTagsIds = action.payload;
		},
		setIsTagsDropdownOpen: (state, action: PayloadAction<boolean>) => {
			state.isTagsDropdownOpen = action.payload;
		},
	},
});

export const {
	actions: templateModuleActions,
	reducer: templateModuleReducer,
	selectors: templateModuleSelectors,
} = templateModuleSlice;
